import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { VariableOptionType } from "../enum/VariableOptionType";
import type { RunnerInfos } from "../interfaces/RunnerInfos";
import type { RunnerType } from "../interfaces/RunnerType";
import { OptionDBInstance } from "../user_options/options_db";
import { createVariableOption } from "./createVariableOption";

export const createRunners = (
  _strength = 18,
  count: 2 | 3 = 2,
  partSelection: RunnerType = OptionDBInstance.getByName(
    LTCaseUserOption.RunnerType,
    "1004",
  ),
): RunnerInfos => {
  return createVariableOption<RunnerInfos>(VariableOptionType.RUNNERS, {
    count,
    fullLength: true,
    partSelection,
  });
};
